import { lazy } from "react"

export const BulkOrdersPage = lazy(() => import("./BulkOrdersPage"))